import React from 'react';
import { FiCode, FiShoppingBag, FiUser, FiTruck, FiGlobe, FiUserCheck, FiHelpCircle, FiMenu } from 'react-icons/fi';

/**
 * Encabezado y Navegación Principal por Audiencia + Enlaces a Plataforma
 * Pestañas independientes: Desarrolladores, Comercios & Tiendas, Clientes / Destinatarios, Repartidores.
 */
export default function HeaderNav({ activeTab, setActiveTab, onToggleMobileMenu }) {
  return (
    <header className="docs-header">
      {/* BARRA SUPERIOR DE NAVEGACIÓN Y LOGO EN MOBILE */}
      <div className="mobile-top-bar">
        {/* LOGO Y MARCA A LA IZQUIERDA */}
        <div className="mobile-brand-logo">
          <img 
            src="/assets/img/veez_logo_transparent.png" 
            alt="Veez Logo" 
            style={{ width: '26px', height: '26px', objectFit: 'contain' }} 
          />
          <span className="mobile-brand-name">VeezDocs</span>
          <span className="mobile-brand-version">v2.0</span>
        </div>

        {/* ICONO HAMBURGUESA SIN FONDO NI TEXTO A LA DERECHA */}
        <button 
          className="mobile-menu-toggle-btn"
          onClick={onToggleMobileMenu}
          aria-label="Abrir menú de navegación"
        >
          <FiMenu size={24} />
        </button>
      </div>

      {/* CONTENEDOR PRINCIPAL DEL HEADER */}
      <div className="header-container">
        
        {/* PESTAÑAS DE AUDIENCIA (SCROLLABLE EN MOBILE) */}
        <nav className="audience-tabs" aria-label="Secciones de Documentación">
          <button
            className={`tab-btn ${activeTab === 'desarrolladores' ? 'active' : ''}`}
            onClick={() => setActiveTab('desarrolladores')}
          >
            <FiCode size={15} /> <span>Desarrolladores</span>
          </button>
          
          <button
            className={`tab-btn ${activeTab === 'comercios' ? 'active' : ''}`}
            onClick={() => setActiveTab('comercios')}
          >
            <FiShoppingBag size={15} /> <span>Comercios & Tiendas</span>
          </button>

          <button
            className={`tab-btn ${activeTab === 'clientes' ? 'active' : ''}`}
            onClick={() => setActiveTab('clientes')}
          >
            <FiUser size={15} /> <span>Clientes / Destinatarios</span>
          </button>

          <button
            className={`tab-btn ${activeTab === 'repartidores' ? 'active' : ''}`}
            onClick={() => setActiveTab('repartidores')}
          >
            <FiTruck size={15} /> <span>Repartidores</span>
          </button>
        </nav>

        {/* ENLACES DE PLATAFORMA (DESKTOP) */}
        <div className="platform-links">
          <a
            href="https://veez.cl"
            target="_blank"
            rel="noopener noreferrer"
            className="platform-link"
          >
            <FiGlobe size={14} /> <span>Sitio Web</span>
          </a>
          <a
            href="https://app.veez.cl"
            target="_blank"
            rel="noopener noreferrer"
            className="platform-link"
          >
            <FiUserCheck size={14} /> <span>Panel Comercio</span>
          </a>
          <a
            href="https://veez.cl/contacto"
            target="_blank"
            rel="noopener noreferrer"
            className="platform-link"
          >
            <FiHelpCircle size={14} /> <span>Soporte</span>
          </a>
        </div>
      </div>
    </header>
  );
}
